<template>
  <div id="barrages-drop">
    <vue-baberrage
      :isShow="barrageIsShow"
      :barrageList="msgsList"
      :maxWordCount="maxWordCount"
      :throttleGap="throttleGap"
      :loop="barrageLoop"
      :boxHeight="boxHeight"
      :messageHeight="messageHeight"
    ></vue-baberrage>
  </div>
</template>
<script>
import Vue from "vue";
import { getMsgwall } from "../api/team_api";
import { vueBaberrage, MESSAGE_TYPE } from "vue-baberrage";
Vue.use(vueBaberrage);
export default {
  name: "Barrages",
  data() {
    return {
      msg: "",
      barrageIsShow: true,
      messageHeight: 3,
      laneNum: 0,
      boxHeight: 190,
      barrageLoop: true,
      maxWordCount: 3,
      throttleGap: 5000,
      msgsList: []
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.addToList();
    });
  },
  methods: {
    addToList() {
      var list = [];
      var id = this.$route.query.id;
      getMsgwall(id).then(response => {
        if (response.data.rs !== null) {
          for (var i = 0; i < response.data.rs.length; i++) {
            list.push({
              id: response.data.rs[i].mt_uuid,
              msg: response.data.rs[i].content,
              time: parseInt(Math.random() * 16 + 3),
              type: MESSAGE_TYPE.NORMAL
            });
          }
          // console.log(parseInt(Math.random() * 15 + 2 ))
        }
        
      });
      this.msgsList = list;
      
    }
  }
};
</script>
<style  lang="scss">
#barrages-drop {
  height: 100%;
  width: 100%;
  .baberrage-item .normal {
    background: none;
    color: #fff;
  }
  .baberrage-stage {
    position: absolute;
    width: 100% !important;
    height: 100%;
    overflow: hidden;
    top: 0;
  }
  .normal .baberrage-msg {
    width: 360px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-top: 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Barrage.vue